import {
  type IWebAnalyticsTotals,
  type TWebAnalyticsOverviewMetric,
} from '@mahawi/eshop-common';
import { Card, Col, Row, Statistic, Typography } from 'antd';
import React from 'react';

import { SPACING } from '../../theme/tokens';
import { formatChangePct, formatMetric, getChangeTone } from './format';
import { type ITrendMetric, TREND_METRICS } from './trend-chart';

const { Text } = Typography;

export const TOTALS_METRICS: ITrendMetric[] = [
  ...TREND_METRICS,
  { metric: 'ga4Sessions', title: 'GA4 sessions (consented sample)' },
];

export function TotalChange({
  metric,
  totals,
}: {
  metric: TWebAnalyticsOverviewMetric;
  totals: IWebAnalyticsTotals<TWebAnalyticsOverviewMetric>;
}): React.ReactElement | null {
  if (!totals.compare) {
    return null;
  }

  const changePct = totals.changePct[metric];

  return (
    <Text type={getChangeTone(metric, changePct)}>
      {formatChangePct(changePct)} (
      {formatMetric(metric, totals.compare[metric])})
    </Text>
  );
}

function Totals({
  totals,
}: {
  totals: IWebAnalyticsTotals<TWebAnalyticsOverviewMetric>;
}): React.ReactElement {
  return (
    <Row gutter={[SPACING.lg, SPACING.lg]}>
      {TOTALS_METRICS.map(
        ({ metric, title }: ITrendMetric): React.ReactElement => (
          <Col key={metric} xs={12} md={6} xl={3}>
            <Card size="small">
              <Statistic
                title={title}
                value={formatMetric(metric, totals.current[metric])}
              />
              <TotalChange metric={metric} totals={totals} />
            </Card>
          </Col>
        ),
      )}
    </Row>
  );
}

export default Totals;
